import {
  ACTIVE_WORKSHOPS_PER_MONTH,
  BASE_URL,
  MANDAY_PER_MONTH_AND_YEAR,
  MANDAY_PER_VENDOR,
  MANDAY_PER_VENDOR_AND_LOCATION,
  MANDAY_PER_VENDOR_AND_MODALITY,
  MANDAY_PER_VENUE,
  TOP_N_SUBJECS,
  TOPICS_PER_VENDOR,
  TRAINER_WORKSHOPS_BY_LANGUAGE,
  TRAINER_WORKSHOPS_BY_STATUS,
  TRAINER_WORKSHOPS_BY_TOPIC,
  TRAINER_WORKSHOPS_BY_TRAINER,
  VENDOR_COMPANY,
  VENDOR_WORKSHOPS_BY_LOCATION,
  VENDOR_WORKSHOPS_BY_TOPIC,
  WORKSHOPS_ATTENDANCE_PER_DEPARTMENT,
  WORKSHOPS_COMPLETION_RATE,
  WORKSHOPS_COUNT_PER_VENDOR,
  WORKSHOPS_PER_PROVIDER,
  WORKSHOPS_STATUS_COUNT,
} from "constants/api";
import axios from "../helpers/axiosInstance";

export async function workshopsPerProvider(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOPS_PER_PROVIDER + params);
  return response.data;
}



export async function workshopsStatusCount(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOPS_STATUS_COUNT + params);
  return response.data;
}

export async function workshopsAttendance(params: string = "") {
  const response = await axios.get(
    BASE_URL + WORKSHOPS_ATTENDANCE_PER_DEPARTMENT + params
  );
  return response.data;
}

export async function activeWorkshopsPerMonth(params: string = "") {
  const response = await axios.get(
    BASE_URL + ACTIVE_WORKSHOPS_PER_MONTH + params
  );
  return response.data;
}

export async function trainerWorkshopByTopic(params: string = "") {
  const response = await axios.get(
    BASE_URL + TRAINER_WORKSHOPS_BY_TOPIC + params
  );
  return response.data;
}

export async function trainerWorkshopByStatus(params: string = "") {
  const response = await axios.get(
    BASE_URL + TRAINER_WORKSHOPS_BY_STATUS + params
  );
  return response.data;
}

export async function vendorWorkshopsByLocation(params: string = "") {
  const response = await axios.get(
    BASE_URL + VENDOR_WORKSHOPS_BY_LOCATION + params
  );
  return response.data;
}

export async function vendorCompanyEngagment(params: string = "") {
  const response = await axios.get(
    BASE_URL + VENDOR_COMPANY + params
  );
  return response.data;
}

export async function vendorWorkshopByTopic(params: string = "") {
  const response = await axios.get(
    BASE_URL + VENDOR_WORKSHOPS_BY_TOPIC + params
  );
  return response.data;
}

export async function vendorWorkshopByTrainer(params: string = "") {
  const response = await axios.get(
    BASE_URL + TRAINER_WORKSHOPS_BY_TRAINER + params
  );
  return response.data;
}

export async function trainerWorkshopByLanguage(params: string = "") {
  const response = await axios.get(
    BASE_URL + TRAINER_WORKSHOPS_BY_LANGUAGE + params
  );
  return response.data;
}

export async function workshopCompletionRate(params: string = "") {
  const response = await axios.get(
    BASE_URL + WORKSHOPS_COMPLETION_RATE + params
  );
  return response.data;
}

export async function topicsPerVendor(params: string = "") {
  const response = await axios.get(BASE_URL + TOPICS_PER_VENDOR + params);
  return response.data;
}

export async function mandayPerVenue(params: string = "") {
  const response = await axios.get(BASE_URL + MANDAY_PER_VENUE + params);
  return response.data;
}

export async function topNSubjects(params: string = "") {
  const response = await axios.get(BASE_URL + TOP_N_SUBJECS + params);
  return response.data;
}

export async function mandayPerVendorAndLocation(params: string = "") {
  const response = await axios.get(BASE_URL + MANDAY_PER_VENDOR_AND_LOCATION + params);
  return response.data;
}

export async function mandayPerVendor(params: string = "") {
  const response = await axios.get(BASE_URL + MANDAY_PER_VENDOR + params);
  return response.data;
}

export async function workshopCountPerVendor(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOPS_COUNT_PER_VENDOR + params);
  return response.data;
}

export async function mandayPerVendorAndModality(params: string = "") {
  const response = await axios.get(BASE_URL + MANDAY_PER_VENDOR_AND_MODALITY + params);
  return response.data;
}

export async function mandayPerMonthAndYear(params: string = "") {
  const response = await axios.get(BASE_URL + MANDAY_PER_MONTH_AND_YEAR + params);
  return response.data;
}
